import { useState } from 'react';

import API from '../../../../../libs/api';
import useAsyncEffect from '../../../foundation/hooks/use-async-effect';
import useFetch from '../../../foundation/hooks/use-fetch/use-fetch';

export function useProviderData({ forceInitialFetch = true } = {}) {
  const [providerData, setProviderData] = useState([]);

  const { fetching: loading, fetch, withFetch } = useFetch({ initialFetching: forceInitialFetch });

  async function getProviderData() {
    const data = await API.getProviderData();
    return data;
  }

  async function fetchProviderData() {
    const data = await getProviderData();
    setProviderData(data);
  }

  async function updateProviderData(providerDataId, overrides) {
    await API.updateProviderDataOverrides(providerDataId, overrides);
    await fetchProviderData();
  }

  useAsyncEffect(async () => {
    if (!forceInitialFetch) {
      return;
    }
    await fetch([fetchProviderData], { throwError: false });
  }, []);

  return {
    providerData,
    loading,
    refreshProviderData: withFetch(fetchProviderData, {
      throwError: false,
    }),
    getProviderData,
    updateProviderData,
  };
}
